import React, {Fragment} from "react";
import { SmartErrorDiv } from "./SmartErrorDiv";

export const emailPattern = {value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: "invalid email address"}
export const phonePattern = {value: /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm, message: "invalid telephone number"}

const FormInput = ( { register, width, pattern, readOnly, label, sectionName, name, style, className, formErrors, maxLength, required, rules } ) =>
{
    const classText = className === undefined ? "form-control" : '' ;
    const styleObj = style === undefined ? {} : style ;

    return (
        <Fragment>
            <input readOnly={readOnly}
                   className={classText} {...register(sectionName + '.' + name,
                rules
            )} />
            <SmartErrorDiv sectionName={sectionName} name={name} maxLength={maxLength} formErrors={formErrors} />
        </Fragment>
    )
}

export {FormInput} ;
